<template>
  <md-modal-dialog
    class="md-dialog"
    @md-opened="event = 'md-opened'"
    @md-clicked-outside="onModalClose"
    @keydown.esc="onModalClose"
    v-slot="{availableTags, availableCategories}"
  >
    <div class="backdrop"></div>
    <ModalWrapper :boxStyles="{paddingBottom: '7px'}">
      <button class="btn btn-icon btn-close" @click="onModalClose">
        <IconCross />
        <span>close</span>
      </button>

      <InterestFilter
        :availableTags="availableTags"
        :availableCategories="availableCategories"
        @submit-active-filters="onSubmit"
        @selection-changed="onChangeSelection"
      />
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
import InterestFilter from './interest-filter';
import ModalWrapper from '@common/modal/simple-modal-wrapper.vue';
import IconCross from '@components/old-home-page/destination-details/icon-cross.vue';

export default {
  name: 'interests-filter-modal',
  components: {
    ModalWrapper,
    InterestFilter,
    IconCross,
  },
  methods: {
    onChangeSelection(tags) {
      this.activeTags = tags;
    },
    onModalClose() {
      this.$modal.submit();
    },
    onSubmit() {
      this.$modal.submit(this.activeTags);
    },
  },
  data() {
    return {
      activeTags: [],
    };
  },
};
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  ); */
  pointer-events: none;
}

.btn {
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  color: #fff;
  cursor: pointer;
}

.btn-close:hover {
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
}

.btn-close {
  position: absolute;
  font-size: 14px;
  color: #fff;

  top: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  padding: 20px 20px 11px;
  border-radius: 0 18px;
  z-index: 10;
}

.btn-close > span {
  font-size: 0;
}
</style>
